import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { DtoPF } from "src/app/shared/models/states";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class TramitacionService {
  env = environment.env;
  tramitacionURL = endpointsURL.tramitacionURL;
  requestURL = endpointsURL.requestURL;

  constructor(private httpClient: HttpClient) {}

  public getTemplatesByCertStatePF(idPetition: string): Observable<any> {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);

    return this.httpClient.get<any>(
      `${this.env}${this.tramitacionURL}certificado/listaPlantillas`,
      { params: params }
    );
  }
  public selectTemplateAndGetInfo(
    idPetition: string,
    idTemplate: string
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_impresoId", idTemplate);

    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}certificado/edit/tramitacion/certificadoIndividual/seleccionarImpreso`,
      {},
      { params: params }
    );
  }

  public selectTemplatesAndGetInfo(
    idPetition: string,
    idsTemplate: string
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_impresosId", idsTemplate);

    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}certificado/edit/tramitacion/certificadoIndividual/seleccionarImpresos`,
      {},
      { params: params }
    );
  }

  public changeStateToPF(
    idPetition: string,
    template: string,
    price: string,
    patterns: string
  ): Observable<any> {
    let dtoPF: DtoPF = {
      peId: idPetition,
      impreso: template ? template : "",
      precio: price ? price.toString() : "0",
      patrones: patterns,
    };
    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}certificado/edit/tramitacion/certificadoIndividual/cambiarEstadoPF`,
      dtoPF
    );
  }
  public getImpresoOfPetition(
    idPetition: string,
    idRelease: string
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("idPeticion", idPetition);
    params = params.append("idRelease", idRelease);

    return this.httpClient.get<any>(
      `${this.env}${this.requestURL}/certificado/impreso`,
      { params: params }
    );
  }
}
